import { PdvService } from './../../services/pdv/pdv.service';
import { Component, Input, EventEmitter, Output } from '@angular/core';

@Component({
    selector: 'product',
    templateUrl: 'product.component.html',
    styleUrls: ['product.component.scss']
})
export class ProductComponent {
    @Input()
    product;
    loadAvatar = false;
    hover = false;
    @Output()
    OnAdd: EventEmitter<boolean> = new EventEmitter<boolean>();
    @Output()
    OnPersonalize: EventEmitter<boolean> = new EventEmitter<boolean>();
    siteClose = false;
    src: any;
    zoom: boolean = false;
    circle = false;
    constructor(private pdvService: PdvService) {
        this.pdvService.pdv.subscribe(
            (data) => {
                this.siteClose = data.closeSite;
            }
        )
    }
    displayComp() {
        this.hover = !this.hover;
    }
    zoomImg() {
        this.zoom = !this.zoom;
    }

    openImage(src) {
        this.src = src;
        var modal = <HTMLElement>document.getElementById('myModal');
        modal.style.display = "block";
    }

    addToBasket() {
        if (this.product.comp || this.product.maxNbrIngOptions > 0 || this.product.hasSupp) {
            this.OnPersonalize.emit(true);
        } else {
            this.OnAdd.emit(true);
        }
    }
}
